import { useTranslation } from '@/i18n';
import { ButtonV2, Tooltip } from '@moneyforward/ap-frontend-components';
import { FC, memo } from 'react';
import type { ProxyOffButtonGroupProps } from '../types';

/** Proxy OFF: Import button + AI OCR + Create new. Link/navigation controlled by parent (InvoiceReportsButtonGroup). */
export const ProxyOffButtonGroup: FC<ProxyOffButtonGroupProps> = memo(
  ({
    reportTypeId,
    onImport,
    onAiOcrClick,
    onCreateNewClick,
    isAiOcrTriggered = false,
    isCreateNewTriggered = false,
    isFetching = false,
    noPayeeTooltip,
  }) => {
    const { t } = useTranslation();
    const isNoPayee = !!noPayeeTooltip;

    return (
      <>
        <Tooltip title={noPayeeTooltip}>
          <span>
            <ButtonV2
              size='sm'
              isTertiary
              isDisabled={isNoPayee || isFetching}
              onClick={onImport}
              data-testid='invoice-reports-import-button'
            >
              {t('invoice_reports.button_groups.import')}
            </ButtonV2>
          </span>
        </Tooltip>
        <Tooltip title={noPayeeTooltip}>
          <span>
            <ButtonV2
              color='primary'
              size='sm'
              isSecondary
              isDisabled={isNoPayee || isAiOcrTriggered || isFetching}
              data-testid='invoice-reports-proxy-off-ai-ocr-bulk'
              onClick={onAiOcrClick}
            >
              {t('invoice_reports.button_groups.ai_ocr_bulk_draft')}
            </ButtonV2>
          </span>
        </Tooltip>
        <Tooltip title={noPayeeTooltip}>
          <span>
            <ButtonV2
              color='primary'
              size='sm'
              isSecondary={false}
              isDisabled={
                isNoPayee || !reportTypeId || isCreateNewTriggered || isFetching
              }
              data-testid='invoice-reports-proxy-off-create-new'
              onClick={onCreateNewClick}
            >
              {t('invoice_reports.button_groups.create_new')}
            </ButtonV2>
          </span>
        </Tooltip>
      </>
    );
  }
);

ProxyOffButtonGroup.displayName = 'ProxyOffButtonGroup';
